import { memo, useEffect, useRef, useState } from "react"
import { HStack, Input, Center, AspectRatio, Image, Float, Tag, Button } from "@chakra-ui/react"
import { InputGroup } from "@/components/ui/input-group"
import { LuSearch, LuShoppingCart, LuMessageCircle } from "react-icons/lu"
import Slider from "react-slick";
import _ from "lodash";
import { useNavigate } from "react-router"

import ProductItem from "components/product/item"
const ProductCarousel = ({ data, settings }) => {
    let sliderRef = useRef(null);
    const [products, setProducts] = useState([])
    const navigate = useNavigate();
    useEffect(() => {

        var data2 = data;
        if (data2.length == 1) {
            data2 = [...data2, data2[0]]
        }
        setProducts(data2);

    }, [data])

    var slide_settings = {
        dots: false,
        infinite: true,
        speed: 500,
        slidesToShow: 3,
        slidesToScroll: 3,
        height: 50,
        autoplay: true,
        // lazyLoad: true

        // centerMode:true
    };

    const [slideSettings, setSlideSetting] = useState({ ...slide_settings });
    useEffect(() => {
        var autoplay = settings?.slide_config?.autoplay
   
        setSlideSetting({ ...slide_settings, autoplay: autoplay });
    }, [settings])

    return (
        <div style={{ width: "99%" }} >
            <Slider {...slideSettings} ref={slider => {
                sliderRef = slider;
            }}>
                {products.map(product => {
                    return (
                        <div >

                            <div style={{ marginLeft: 6, padding: 2 }}>
                                <ProductItem data={product}></ProductItem>
                            </div>

                        </div>

                    )
                })}





            </Slider>


        </div>
    )
}

export default memo(ProductCarousel)